module.exports = __webpack_public_path__ + "img/home.2c12eb0c.png";